<template>
  <div class="app vh-100">
    <div class="container vh-100">
      <b-row class="justify-content-center align-items-center vh-100">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <label style="font-size: 16px; text-align: center">Confirm your email address.</label>
                  <p></p>
                  <p> We have sent an email with a confirmation link to your email address. In order to complete the sign-up process, please click the confirmation link.</p>
                  <p> If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form.</p>
                  <p> If you need assistance, feel free to contact us through Telegram: <a ref="noreferrer" target="_blank" href="https://telegram.me/brilomSupport">@brilomsupport</a> / 267 397 6462
                    or Email: admin@brilom.com</p>
                </b-form>
                Go to<router-link class="btn btn-link" to="/login">Login</router-link>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

export default {
  name: 'RegistrationCompleted'
}
</script>

<style scoped>

</style>
